import { FC, lazy, LazyExoticComponent } from "react";

import { ScannerType } from "models/scanner-type";

import type { CapturerProps } from "./Capturer";

// Lazily-loaded capturer per scanner. Each `import()` is a separate chunk, so a
// scanner's UI + SDK is only fetched when that scanner is actually selected at
// runtime — bundling several scanners does not grow the initial bundle.
export const capturerRegistry: Record<
  ScannerType,
  LazyExoticComponent<FC<CapturerProps>>
> = {
  [ScannerType.REGULA]: lazy(() => import("./Capturer-REGULA")),
  [ScannerType.MICROBLINK_NEW]: lazy(() => import("./Capturer-MICROBLINK_NEW")),
  [ScannerType.MICROBLINK_BLINKID]: lazy(
    () => import("./Capturer-MICROBLINK_BLINKID")
  ),
  [ScannerType.INCODE]: lazy(() => import("./Capturer-INCODE")),
};
